import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Auth Guard
 * Protects routes that require authentication
 * Redirects to login if user is not authenticated
 */
export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // Check if user is authenticated
    if (authService.isAuthenticated()) {
        return true;
    }

    // User not authenticated - redirect to login
    // Store the attempted URL for redirecting after login
    console.warn(`🔒 Access denied to ${state.url}. Redirecting to login...`);

    return router.createUrlTree(['/admin/login'], {
        queryParams: { returnUrl: state.url }
    });
};
